import usuariosRotas from './usuarios/UsuariosRotas'
import perfilAcessoRotas from './perfisacesso/PerfilAcessoRotas'
import regraAcessoRotas from './regrasacesso/RegrasAcessoRota'
import solicitacoesAcessoRotas from './solicitacoesacesso/SolicitacoesAcessoRotas'
import aplicacoesRotas from './aplicacoes/AplicacoesRotas'

export default {
    path: 'controleacesso',
    name: 'ControleAcesso',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        usuariosRotas,
        perfilAcessoRotas,
        regraAcessoRotas,
        solicitacoesAcessoRotas,
        aplicacoesRotas
    ]
}
